import { GUIDE_TOUR_EXPIRES_AT_PATTERN } from '../utils/tourRuntime'
import { GuideTourValidationError } from './errors'

export const validateOptionalGuideTourExpiresAt = (
  expiresAt: string | undefined,
  fieldName: string
): void => {
  if (expiresAt === undefined) {
    return
  }

  if (typeof expiresAt !== 'string') {
    throw new GuideTourValidationError(`${fieldName} must be a string`)
  }

  if (!GUIDE_TOUR_EXPIRES_AT_PATTERN.test(expiresAt)) {
    throw new GuideTourValidationError(
      `${fieldName} must use YYYY-MM format with month 01-12`
    )
  }
}
